module.exports = __webpack_public_path__ + "media/components/HowItWorks/components/WeWereFeatured/assets/vice-8a695fdbe72a2a323d1c636529ee8046.png";